import { filterSegments, filterTakeoverPoints } from './filters'
import type { FilterState, SegmentCollection, TakeoverCollection } from './types'

export interface LayerBundle {
  segments: SegmentCollection
  takeover: TakeoverCollection
}

export interface LayerCounts {
  segmentFeatures: number
  takeoverFeatures: number
  undrivenFeatures: number
}

export interface ComposedLayerData extends LayerBundle {
  counts: LayerCounts
}

export function countLayerFeatures(
  segments: SegmentCollection,
  takeover: TakeoverCollection,
): LayerCounts {
  return {
    segmentFeatures: segments.features.length,
    takeoverFeatures: takeover.features.length,
    undrivenFeatures: segments.features.filter((f) => f.properties.trust === 'undriven').length,
  }
}

/** Single source of truth for what the map layers should display. */
export function composeLayerData(bundle: LayerBundle, filters: FilterState): ComposedLayerData {
  const segments = filterSegments(bundle.segments, filters)
  const takeover = filterTakeoverPoints(bundle.takeover, filters)
  return {
    segments,
    takeover,
    counts: countLayerFeatures(segments, takeover),
  }
}